export default __webpack_public_path__ + "static/media/udea-facultad-ingenieria.a11238be.png";